module.exports = __webpack_public_path__ + "static/media/depresion.ec815356.svg";